export default __webpack_public_path__ + "static/media/lieferheld_background_s2.5ff44971.jpg";